import * as moment from 'moment';


interface IPickerOptions {
  value?: moment.Moment;
  position: {
    left: number,
    top: number
  };
  config: {
    showTime?: boolean,
    isTimePicker: boolean,
    onChange?: (date: moment.Moment, dateString: string) => void
  };
}

export default class StupidPickerStore {
  public isPreviewMode = false;

  public value?: moment.Moment;

  public isPickerOpened = false;

  public position = { left: -1000, top: -1000 };

  public config: {
    showTime: boolean,
    isTimePicker: boolean
    onChange?: (date: moment.Moment, dateString: string) => void
  } = { showTime: false, isTimePicker: true };

  public constructor(private setState: any) { }


  public togglePicker = (options: IPickerOptions) => {
    if (this.isPickerOpened) {
      this.closePicker();
    } else {
      this.openPicker(options);
    }
  }

  public closePicker = () => {
    if (this.isPickerOpened) {
      this.setState({
        isPickerOpened: false,
        position: { left: -1000, top: -1000 }
      });
    }
  }

  public openPicker = (options: IPickerOptions) => {
    this.setState({
      value: options.value,
      isPickerOpened: true,
      position: options.position,
      config: options.config
    });
  }

  public setValue = (date: moment.Moment) => {
    this.setState({ value: date });
  }

}
